import React from "react";

import FieldContainer from "./FieldContainer";
import Label from "./Label";
import { containerClasses, inputClasses, wrapperClasses } from "./styles";

import type { JSX } from "react";

import type { InputProps } from "./types";

export default function ReadOnlyInput({
  icon,
  value,
  name,
  label,
  sublabel,
  isCompact,
  className,
  isNoWrap,
}: InputProps): JSX.Element {
  return (
    <FieldContainer
      className={className}
      isCompact={isCompact}
      isNoWrap={isNoWrap}
    >
      {label ? (
        <Label
          isCompact={isCompact}
          label={label}
          name={name}
          sublabel={sublabel}
        />
      ) : null}
      <div className={wrapperClasses({ isCompact })}>
        <div className={containerClasses()}>
          <div className="text-muted-foreground pointer-events-none absolute inset-y-0 left-0 flex items-center pl-[0.46875rem]">
            {icon}
          </div>
          <input
            disabled
            className={inputClasses({ icon, isReadOnly: true })}
            type="text"
            value={value}
          />
        </div>
      </div>
    </FieldContainer>
  );
}
